// extracted by mini-css-extract-plugin
export default {"root":"CarouselMobile+SizeRec-module-root-F_69t"};